module.exports = "https://static.im-cdn.com/mjc/storefront/Comfort/static/media/Zoom.bfc15475.svg";